/* eslint-disable max-len */
import { useContext, useEffect, useMemo, useState } from "react";

import SecondLayout from "../../layouts/SecondLayout";
import { Route, Routes } from "react-router-dom";
import Domains from "./Domains";
import ChildDomains from "../../components/ChildDomains";
import CompetenciesList from "../../components/CompetenciesList";
import { SemesterContext } from "../../context/SemesterContext";
import { UserContext } from "../../context/UserContext";
import axios from "axios";
import SnackBar from "../../components/SnackBar";
import { handleJWTError } from "../../hooks/jwtErrHandler";
function QuestsPage() {
  const [warningMessage, setWarningMessage] = useState<any>(null);
  const semesterContext = useContext(SemesterContext);
  const { user, selectedVersion, setVersion } = useContext(UserContext);

  useEffect(() => {
    if (
      !window.location.pathname.includes("/explore") ||
      user.role === 1 ||
      !semesterContext.selectedSemester?.label
    ) {
      return;
    }
    fetchSemesterCompetency();
  }, [semesterContext.selectedSemester?.label, selectedVersion, warningMessage]);

  const fetchSemesterCompetency = () => {
    if (selectedVersion !== 0) {
      axios
        .get(
          `/semester/competency?semester=${
            semesterContext.selectedSemester.label
          }&university_code=${
            user?.university_code || "CMKL"
          }&curriculum_version=${selectedVersion}`
        )
        .then((res: any) => {
          if (res.data.semestercompetencies?.length === 0) {
            console.log("if condition");
            setWarningMessage(
              "No competencies found for semester and curriculum version. Try selecting a different version."
            );
          } else {
            setWarningMessage(null);
          }
        })
        .catch((err) => {
          handleJWTError(err);
        });
    } else {
      axios
        .get(`/version?university_code=CMKL`)
        .then((res) => {
          const active_version = res.data.versions.find(
            (v: any) => v.status === "Active Prime"
          ).version_number;
          axios
            .get(
              `/semester/competency?semester=${
                semesterContext.selectedSemester.label
              }&university_code=${
                user?.university_code || "CMKL"
              }&curriculum_version=${active_version}`
            )
            .then((res: any) => {
              if (res.data.semestercompetencies?.length === 0) {
                setWarningMessage(
                  "No competencies found for semester and curriculum version. Try selecting a different version."
                );
              } else {
                setWarningMessage(null);
              }
            })
            .catch((err) => {
              handleJWTError(err);
            });
        })
        .catch((err) => {
          handleJWTError(err);
        });
    }
  };

  return (
    <SecondLayout>
      <Routes>
        <Route index element={<Domains />} />
        <Route path="child" element={<ChildDomains />} />
        <Route
          path="child/competencies"
          element={<CompetenciesList warningMessage={warningMessage} />}
        />
      </Routes>
    </SecondLayout>
  );
}
export default QuestsPage;
